import React from "react";
import { constants } from "../../constants";
import { useHistory, useLocation } from "react-router-dom";

export const CompletionState = (props) => {
  const history = useHistory();
  const location = useLocation();

  const data = location?.state?.data;
  if (!data) {
    throw new Error("Can't use this component without page data.");
  }

  // Accepts the following props inside react-router location property while route transitions
  const { name, goTo, title, redirectTo, subTitle, completed, heading } = data;

  return (
    <div className="flex flex-col justify-evenly h-screen items-center">
      <div>
        <img
          src={
            completed
              ? constants.postSpocConfirmation
              : constants.preSpocConfirmation
          }
          alt="pre-tick"
        />
      </div>
      <div className="">
        <div className="text-center">
          <h3 className="text-2xl">{heading}</h3>
        </div>
        <div className="text-center">
          <h1 className="font-medium md:text-6xl text-4xl max-w-md">{title}</h1>
        </div>
        <div className=" text-center">
          <h3 className="text-xl ">{subTitle}</h3>
          <h3 className="font-medium text-xl ">{name}</h3>
        </div>
      </div>

      <button
        onClick={() => history.push(redirectTo || "/")}
        className="bg-themeYellow shadow-md transform hover:scale-110 hover:-translate-x-1 ease-in-out duration-300 rounded-md border-gray-500 uppercase px-32 py-4 font-bold text-base leading-4 tracking-widest outline-none"
      >
        {goTo || "complete form"}
      </button>
    </div>
  );
};
